export default __webpack_public_path__ + "static/media/andes_a_la_selva_8.805205c0.JPG";